
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { BarcodeOrderListItem } from "@/models/api/barcodeSystem/barcodeOrders/get";
import { formatDateWithTime } from "@/utils";

const loadModuleState = getModule(LoadModule);
const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component
export default class LoadOrderTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get barcodeOrders(): Array<BarcodeOrderListItem> {
    return loadModuleState.currentLoadOrders;
  }

  get selectedItemCount(): number {
    return loadModuleState.getSelectedLoadOrderCount;
  }

  get selectedItems(): Array<any> {
    return loadModuleState.getSelectedLoadOrders;
  }

  get totalItems() {
    if (loadModuleState.currentLoadOrders) {
      return loadModuleState.currentLoadOrders.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  onDoubleClicked(data) {
    barcodeOrderModuleState.viewBarcodeOrderShortcutAction( {selectedItems: [data]});
  }

  onRowClick(data) {
    loadModuleState.switchLoadOrderSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      loadModuleState.switchLoadOrderSelectionStatus(item.id);
    });
  }
}
